import FieldType from './FieldType';
import { useTranslation } from '../../StateManagment/TranslationContext';
import { QuestionnaireContext } from "../../StateManagment/Questionnaire";
import { useContext } from "react"
import Tooltip from "../../components/common/Tooltip.jsx";
import ReadAloudButton from './ReadAloudButton';
import RequiredMark from './RequiredMark';

/**
 * @param {object} props
 * @param {object} props.field - QuestionnaireFields doc for this question
 * @param {string} props.compagnyId - Tenant CompagnyID
 * @param {object} props.questionaire - Parent Questionnaires doc
 * @param {string} props.languageCode - Active language code (e.g. 'nl')
 * @param {boolean} props.isVisible - Whether this question's step is on screen
 * @param {number} [props.questionNumber] - 1-based position within the section (display-only chip)
 * @param {number} [props.questionTotal] - Question count of the section (chip hidden when <= 1)
 */
const Fields = ({
    field,
    compagnyId,
    questionaire,
    languageCode,
    isVisible,
    questionNumber,
    questionTotal
}) => {
  // Context
  const { translations } = useTranslation();

    return (
        <div className="question-field-outer-container" key={field.ID}>
            <div className='question-container'>
                {/* Display-only counter; hidden outside the qo-redesign look (CSS) */}
                {questionNumber && questionTotal > 1 ? (
                    <div className="qo-question-chip">{questionNumber} / {questionTotal}</div>
                ) : null}
                <div className='field-title-container'>
                    <h2>
                        {translations[field.ID] || field.Question}
                        <RequiredMark required={field.Required} label={translations?.["Verplichte vraag"]} />
                    </h2>
                    <div id='field-title-buttons-container'>
                        <Tooltip content="Lees vraag voor" width={'40px'} top='40px'>
                            <ReadAloudButton text={translations[field.ID] || field.Question} type={field.Type}/>
                         </Tooltip>
                    </div>

                </div>
                <div className='explainer-container'>
                    <p>{translations[`${field.ID}_explainer`] || field.Explainer}</p> 
                </div>
                <FieldType 
                field={field} 
                compagnyId={compagnyId} 
                questionaire={questionaire}
                languageCode={languageCode}
                isVisible={isVisible}
                />
            </div>
        </div>
    )
}

export default Fields
